const HeroSection = ({ title, description }) => `
    <section class="hero-section reveal" role="region">
        <div class="title">${title}</div>
        <span class="description">${description}</span>
        <button class="jump-to-element" aria-label="jump to article">
            <img src="assets/images/icon-chevron-down.svg" alt="icon-down" />
        </button>
    </section>
`;

// Jumps to the article section
window.addEventListener('DOMContentLoaded', () => {
  const jumpElement = document.querySelector('.jump-to-element');
  const articleElement = document.querySelector('.range-calculator');

  if (jumpElement && articleElement) {
    jumpElement.addEventListener('click', () => {
      articleElement.scrollIntoView({ behavior: 'smooth' });
    });
  }
});

export default HeroSection;
